export default (theme) => ({
  infoWrapper: {
    width: '95%',
    margin: '45px auto',
  },
  addressWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  appointmentDetail: {
    border: `1px solid ${theme.palette.disabled.main}`,
    borderRadius: 33,
    padding: '50px 40px',
    marginBottom: 20,
    [theme.breakpoints.down('xl')]: {
      padding: 25,
    },
  },
  virtualJoinWrapper: {
    width: 'calc(100% / 12 * 6)',
    textAlign: 'center',
    margin: '20px 0 40px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% / 12 * 7)',
    },
  },
  healthcareServiceName: {
    fontWeight: 'bold',
    textTransform: 'capitalize',
    [theme.breakpoints.down('sm')]: {
      fontSize: 24,
    },
  },
  providerName: {
    textTransform: 'capitalize',
  },
  roomFullName: {
    textTransform: 'capitalize',
    lineHeight: 1,
  },
  appointmentStartDate: {
    fontWeight: 'bold',
    marginTop: 10,
    lineHeight: 1,
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
  instruction: {
    marginTop: 10,
    wordBreak: 'break-all',
    whiteSpace: 'normal',
  },
  addressInfo: {
    width: 'calc(100% / 12 * 6)',
    textAlign: 'center',
    marginTop: 50,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      marginTop: 20,
    },
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% / 12 * 10)',
    },
  },
  joinButtonIcon: {
    minWidth: 43,
    minHeight: 43,
    width: 43,
    height: 43,
    fill: theme.palette.background.white,
    [theme.breakpoints.down('xl')]: {
      minWidth: 30,
      minHeight: 30,
      width: 30,
      height: 30,
    },
  },
  controlButtonText: {
    marginLeft: 10,
    fontSize: 19,
    [theme.breakpoints.down('xl')]: {
      fontSize: 14,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
    },
  },
  virtualIconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 340,
    width: '100%',
    borderRadius: 33,
    backgroundColor: `${theme.palette.secondary.main}20`,
    [theme.breakpoints.down('xl')]: {
      height: 300,
    },
    [theme.breakpoints.down('sm')]: {
      height: 142,
    },
  },
  appointmentJoinButton: {
    margin: '20px 0',
    minWidth: 200,
    width: 'auto',
    height: 70,
    [theme.breakpoints.down('xl')]: {
      minWidth: 160,
      height: 50,
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: 130,
      height: 40,
    },
  },
  guideLink: {
    textDecoration: 'none',
    textTransform: 'lowercase',
    color: theme.palette.link.main,
  },
  guideText: {
    [theme.breakpoints.down('sm')]: {
      fontSize: 9,
    },
  },
  virtualIcon: {
    width: 225,
    [theme.breakpoints.down('xl')]: {
      width: 200,
    },
    [theme.breakpoints.down('sm')]: {
      width: 94,
    },
  },
  appointmentAttachments: {
    height: 440,
    width: '100%',
    border: `1px solid ${theme.palette.disabled.main}`,
    borderRadius: 33,
    padding: '0 10px 30px',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('xl')]: {
      height: 420,
    },
    [theme.breakpoints.down('md')]: {
      margin: '45px auto',
    },
  },
  appointmentInvoices: {
    height: 440,
    width: '100%',
    border: `1px solid ${theme.palette.disabled.main}`,
    borderRadius: 33,
    padding: '0 10px 30px',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 45,
    [theme.breakpoints.down('xl')]: {
      height: 440,
    },
    [theme.breakpoints.down('md')]: {
      margin: '45px auto',
    },
  },
  attachmentsHeaderTitleWrapper: {
    width: 'calc(100% - 50px)',
  },
  attachmentsHeader: {
    padding: '50px 30px 15px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('xl')]: {
      padding: 25,
    },
  },
  uploadIcon: {
    fill: theme.palette.background.white,
    width: 16,
    height: 16,
  },
  uploadIconActive: {
    fill: theme.palette.primary.main,
    pointerEvents: 'initial',
  },
  attachmentsWrapper: {
    padding: '0 20px 10px 30px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    overflowX: 'hidden',
    width: '100%',
    height: '100%',
    flex: 1,
    [theme.breakpoints.down('xl')]: {
      padding: '0 15px 10px 25px',
    },
  },
  appointmentAttachmentItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '10px 0',
    borderBottom: `1px solid ${theme.palette.disabled.main}`,
  },
  attachmentName: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  attachmentInfoWrapper: {
    width: '60%',
  },
  attachmentFileName: {
    lineHeight: 1,
    paddingLeft: 10,
  },
  attachButton: {
    minWidth: 30,
    minHeight: 30,
    width: 30,
    height: 30,
    padding: 0,
    borderRadius: '50%',
  },
  attachIcon: {
    width: 20,
    height: 20,
    fill: theme.palette.background.white,
  },
  attachmentProviderName: {
    display: 'inline-block',
    paddingLeft: 40,
    color: theme.palette.disabled.main,
    textTransform: 'capitalize',
  },
  attachLabel: {
    color: '#fff',
    display: 'none',
  },
  attachmentDate: {
    color: theme.palette.disabled.main,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 20,
    },
  },
  uploadFileBtn: {
    pointerEvents: 'none',
    cursor: 'pointer',
    padding: 0,
    background: theme.palette.disabled.main,
    border: 'none',
    minWidth: 42,
    minHeight: 42,
    width: 42,
    height: 42,
    borderRadius: 4,
    '& input': {
      display: 'none',
    },
    '& svg': {
      width: '60%',
      height: '60%',
      cursor: 'pointer',
    },
  },
  uploadFileBtnActive: {
    pointerEvents: 'initial',
    background: theme.palette.primary.main,
  },

  noDocuments: {
    margin: 'auto',
  },
  noInvoices: {
    margin: 'auto',
  },
  statusLabel: {
    marginTop: 8,
  },
  providerTag: {
    display: 'inline-block',
    color: theme.palette.secondary.main,
    padding: '6px 8px',
    backgroundColor: `${theme.palette.secondary.main}50`,
    borderRadius: 20,
    margin: '10px 10px 0 0',
  },
  qualificationsWrapper: {
    padding: '0 0 20px 0',
  },
  providerInstructionsWrapper: {
    marginTop: 30,
    wordBreak: 'break-all',
    whiteSpace: 'normal',
  },
  invoiceBox: {
    padding: 10,
    borderBottom: '1px solid #ccc',
  },
  circleIconDanger: {
    fill: '#C62439',
  },
  circleIconWarning: {
    fill: '#FB9F1E',
  },
  circleIconSuccess: {
    fill: '#00AD5D',
  },
  status: {
    display: 'flex',
    alignItems: 'center',
  },
  payHere: {
    padding: 8,
    height: 25,
    fontSize: 12,
  },
  linkToAttachment: {
    cursor: 'pointer',
  },
});
